import artikel from "./artikel"
import kunde from "./kunde"

export default {
  artikel,
  kunde
}
